import { Stack, useColorModeValue } from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/hooks";
import { Collapse } from "@chakra-ui/transition";
import { useState } from "react";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
import UserChatDetails from "./UserChatDetails";
import { useEffect } from "react";
import { getUserGroups } from "./service";
import { useGetState } from "../../context/useGetState";
import FullPageLoader from "../../components/full-page-loader";
import MobileBottomNavigation from "../../components/meetings/MobileBottomNavigation";
import GroupMobileBottomNavigation from "./GroupMobileBottomNavigation";
import { useLocation } from "react-router-dom";

export const setRoomID = (id) => {
  if (sessionStorage.getItem("ROOM_ID")) {
    sessionStorage.removeItem("ROOM_ID");
  }
  sessionStorage.setItem("ROOM_ID", id);
};
function GroupChat() {
  const { state } = useGetState();
  const { userInfo } = state;
  const { openChatDetails } = state || {};
  const containerColor = useColorModeValue("#fff", "#020B19");

  const [showChatDetails, setShowChatDetails] = useState(
    openChatDetails || true
  );
  const [groups, setGroups] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [selectedChat, setSelectedChat] = useState("");

  const [currentMobileScreenState, setCurrentMobileScreenState] = useState(0);
  const { account_type, id } = userInfo || {};
  ///////////////////////////////////////////
  const [currentGroupChat, setCurrentGroupChat] = useState(undefined);
  const [receiverCurrentChat, setReceiverCurrentChat] = useState(undefined);
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const [isUserChatDetailsOpen, setIsUserChatDetailsOpen] = useState(true);
  const [incomingLastMessage, setIncomingLastMessage] = useState(undefined);

  const location = useLocation();
  const joinedgroupData = location.state?.groupData || undefined;

  // console.log('currentGroupChat: ', currentGroupChat);
  // console.log('receiverCurrentChat: ', receiverCurrentChat);
  
  useEffect(() => {
    getUserGroups(setGroups, setPageLoading);
  }, []);
  const chats = groups?.find((group) => group?.id === currentGroupChat?.id);

  const handleGroupChatChange = (groupChat) => {
    setCurrentGroupChat(groupChat);
  };

  return pageLoading ? (
    <FullPageLoader />
  ) : (
    <GroupMobileBottomNavigation current={currentMobileScreenState}>
      <LeftSection
        flex={["1", "3", "4", "2"]}
        maxW={["100%", "300px"]}
        w={["100%", "300px"]}
        setShowChatDetails={setShowChatDetails}
        groups={groups}
        setSelectedChat={setSelectedChat}
        selectedChat={selectedChat}
        chats={chats}
        userInfo={userInfo}
        currentMobileScreenState={currentMobileScreenState}
        setCurrentMobileScreenState={setCurrentMobileScreenState}
        ///////////////////////////////////////////////
        currentGroupChat={currentGroupChat}
        changeGroupChat={handleGroupChatChange}
        receiverCurrentChat={receiverCurrentChat}
        joinedgroupData={joinedgroupData}
        incomingLastMessage={incomingLastMessage}
      />

      <RightSection
        flex={["inset", showChatDetails ? "4" : "6"]}
        h={["unset", window.innerHeight - 105]}
        w={["100%", "unset"]}
        groups={groups}
        chats={chats}
        userId={id}
        accountType={account_type}
        selectedChat={selectedChat}
        user={userInfo}
        setCurrentMobileScreenState={setCurrentMobileScreenState}
        ///////////////////////////////////////////////
        currentGroupChat={currentGroupChat}
        setReceiverCurrentChat={setReceiverCurrentChat}
        onToggle={onToggle}
        setIsUserChatDetailsOpen={setIsUserChatDetailsOpen}
        isUserChatDetailsOpen={isUserChatDetailsOpen}
        setIncomingLastMessage={setIncomingLastMessage}

      />
      
      <UserChatDetails
        isOpen={isOpen}
        display={isUserChatDetailsOpen === true ? "block" : "none"}
        flex="2"
        setShowChatDetails={setShowChatDetails}
        setGroups={setGroups}
        groups={groups}
        chats={chats}
        user={userInfo}
        currentGroupChat={currentGroupChat}
        setCurrentMobileScreenState={setCurrentMobileScreenState}
      />
      
      </GroupMobileBottomNavigation>

  );
}

export default GroupChat;
